import { serviceDefaultDataMembers } from '../../treeVisitors/createTagsSubTreesVisitor/index';
import { pathToKey } from '../deleteMembers/index';

export const createNewCategoriesEffect = (docsTree, menuConfig) => {
  menuConfig.categories.forEach(({ path, name }) => {
    const treeKey = pathToKey(path);
    //shouldAddCategory
    if (!docsTree[treeKey]) {
      docsTree[treeKey] = {
        data: serviceDefaultDataMembers(name, path),
      };
    }
  });
};
